
export default {
  name: 'HeaderVehicleSelector',

  computed: {
    selectedVehicle() {
      return this.$store.getters.selected_vehicle
    },
  },

  created() {
    this.$store.dispatch('loadVehicleSearchHistory').then(() => {
      this.$store.dispatch('loadSelectedVehicle')
    })
  },
}
